import React from 'react';
import { useTheme } from '../../theme/enhanced-theme-provider';

interface ThemeAwareLogoProps {
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  width?: string | number;
  height?: string | number;
}

export const ThemeAwareLogo: React.FC<ThemeAwareLogoProps> = ({ 
  alt = "Silver Falls Capital", 
  style = {}, 
  className,
  width,
  height
}) => {
  const { themeMode } = useTheme();
  
  // Determine if we should use the dark logo
  // Use white logo for dark mode or when system preference is dark in auto mode
  const useDarkLogo = themeMode === 'dark' || 
    (themeMode === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  
  const logoSrc = useDarkLogo ? '/sfc-logo-white.png' : '/sfc-logo.png';
  
  const logoStyle = {
    ...style,
    ...(width && { width }),
    ...(height && { height })
  };
  
  return (
    <img 
      src={logoSrc}
      alt={alt}
      style={logoStyle}
      className={className}
    />
  );
};